import { setDigitalData } from './analytics';
import { analyticsTrack } from './track-digital-data';

const trackElementInViewport = (element: Element, index: number) => {
  let hasLogged = false;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !hasLogged) {
        analyticsTrack('change_gallery', { hash: index });
        hasLogged = true;
        observer.disconnect();
      }
    });
  });
  observer.observe(element);
};

const updatePageTemplate = (pageName: string | undefined | null) => {
  if (pageName === 'pagelle') {
    setDigitalData([{ targetKey: 'pagetemplate', value: 'pagelle' }]);
  } else if (pageName === 'probabili-formazioni') {
    setDigitalData([{ targetKey: 'pagetemplate', value: 'probabili-formazioni' }]);
  }
};

export const trackPlayersCards = () => {
  const tabs = Array.from(document.querySelectorAll('.ftbl__team-tabs-wrapper__tab > input'));
  const teamsList = Array.from(document.querySelectorAll('.ftbl__football-team'));
  const pageName = document.querySelector('.ftbl__team-tabs-wrapper')?.getAttribute('data-team-type');

  updatePageTemplate(pageName);

  const trackVisibleTeam = (isPrimaryTab: boolean = true) => {
    const visibleTeamwrapper = teamsList.find((team) => window.getComputedStyle(team).display !== 'none');
    const visibleTeam = visibleTeamwrapper?.firstElementChild?.querySelectorAll('.ftbl__football-team__player-wrapper');

    visibleTeam &&
      visibleTeam.forEach((card, index) =>
        trackElementInViewport(card, isPrimaryTab ? index + 1 : visibleTeam.length + index + 1)
      );
  };

  tabs.forEach((tab: HTMLInputElement) => {
    if (!tab.checked) {
      const handleClick = () => {
        trackVisibleTeam(false);
        tab.removeEventListener('click', handleClick);
      };

      tab.addEventListener('click', handleClick);
    }
  });

  trackVisibleTeam();
};
